<!-- 
  装配单管理
  相关 JavaScript脚本在config/mixin文件中
 -->

<template>
  <div class="list">
    <list-head @searchEmit="search" placeholder="请输入装配单编号进行搜索">
      <span slot="title">装配单管理</span>
      <template slot="options" v-for="btn in topPermission">
        <el-button size="small" v-if="btn === 'add'" type="primary" @click="addnew">{{topMap[btn]}}</el-button>
        <el-button size="small" v-else @click="topBtnHandle(btn)">{{topMap[btn]}}</el-button>
      </template>
    </list-head> 
    <div class="content">
      <list-panel ref="panel" :sortArray="sortArray" @ssChange="refreshTable" @refresh="getList" :belonger="belonger"></list-panel>
      <list-table
        ref="table"
        :summaryInfo = "summaryInfo"
        :tableHead="listHead"
        :tableData="listData"
        :listMenu="hasListMenu"
        @details="openDetail"
        @edit="editItem"
        @refresh="getList"
        @recall="handleRecall">
      </list-table>
      
      <div class="foot-wrapper">
        <list-footer
          ref="foot"
          @deleteArr="deleteRows"
          @cancelCheck="cancelTableCheck"
          :permission="botPermission"
          @archived="handlePerm">
        </list-footer>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <transition name="slide">
      <detail
        ref="detail"
        v-if="detailShow"
        :id="detailId"
        :moduleName="popModel"
        @addNew="newWorkFlow"
        @close="closeDetail"
        @refresh="getList"
        @edit="editItem"
        @recall="handleRecall">
      </detail>
    </transition>
    <transition name="fade">
      <div class="detail-bg" v-if="detailShow" @click="detailShow=false"></div>
    </transition>
    <add-new
      ref="addNew"
      v-if="addnewShow"
      @closeDialog="addnewShow=false"
      @refresh="getList"
      :addnewProp="addnewProp">
    </add-new>
    <Print v-if="choosePrintType" 
      :entityIdProp="printIds"
      :moduleName="moduleName"
      :refType="refType"
      @closeDialog="choosePrintType = false"
      >
    </Print>
    <export v-if="exportShow" @export="exportFile" @closeDialog="closeExport"></export>
    <batch-edit v-if="batchEditShow" :selectIds="getSelectIds" @refresh="success" @closeDialog="batchEditShow = false"></batch-edit>

  </div>
</template>

<script>
import * as mixin from 'src/config/mixin'

export default {
  created () {
    this.initList('assemble')
    this.getList()
  },
  mixins: [mixin.list]
}
</script>




// WEBPACK FOOTER //
// assemble.vue?d8fe2500